"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("antd/lib/button"));

var _cascader = _interopRequireDefault(require("antd/lib/cascader"));

var _reactRedux = require("react-redux");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

var _reselect = require("reselect");

var _input = _interopRequireDefault(require("antd/lib/input"));

require("@fortawesome/fontawesome-pro/css/all.min.css");

require("froala-editor/js/froala_editor.pkgd.min.js");

require("froala-editor/js/plugins/align.min");

require("froala-editor/js/plugins/char_counter.min");

require("froala-editor/js/plugins/code_beautifier.min");

require("froala-editor/js/plugins/code_view.min");

require("froala-editor/js/plugins/colors.min");

require("froala-editor/js/plugins/draggable.min");

require("froala-editor/js/plugins/emoticons.min");

require("froala-editor/js/plugins/font_family.min");

require("froala-editor/js/plugins/font_size.min");

require("froala-editor/js/plugins/fullscreen.min");

require("froala-editor/js/plugins/help.min");

require("froala-editor/js/plugins/image.min");

require("froala-editor/js/plugins/inline_class.min");

require("froala-editor/js/plugins/inline_style.min");

require("froala-editor/js/plugins/link.min");

require("froala-editor/js/plugins/lists.min");

require("froala-editor/js/plugins/paragraph_format.min");

require("froala-editor/js/plugins/paragraph_style.min");

require("froala-editor/js/plugins/print.min");

require("froala-editor/js/plugins/quote.min");

require("froala-editor/js/plugins/save.min");

require("froala-editor/js/plugins/special_characters.min");

require("froala-editor/js/plugins/table.min");

require("froala-editor/js/plugins/url.min");

require("froala-editor/js/plugins/video.min");

require("froala-editor/js/plugins/word_paste.min");

require("froala-editor/css/froala_style.min.css");

require("froala-editor/css/froala_editor.pkgd.min.css");

require("froala-editor/css/plugins/char_counter.min.css");

require("froala-editor/css/plugins/code_view.min.css");

require("froala-editor/css/plugins/colors.min.css");

require("froala-editor/css/plugins/draggable.min.css");

require("froala-editor/css/plugins/emoticons.min.css");

require("froala-editor/css/plugins/fullscreen.min.css");

require("froala-editor/css/plugins/help.min.css");

require("froala-editor/css/plugins/image.min.css");

require("froala-editor/css/plugins/special_characters.min.css");

require("froala-editor/css/plugins/table.min.css");

require("froala-editor/css/plugins/video.min.css");

var _reactFroalaWysiwyg = _interopRequireDefault(require("react-froala-wysiwyg"));

var _axios = _interopRequireDefault(require("axios"));

var _moment = _interopRequireDefault(require("moment"));

var _topic = require("../../../redux/topics/topic.types");

var _Util = require("../../../components/util/Util");

var _util = require("../../../service/util");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import * as html2pdf from 'html2pdf.js';
const AxiosInstance = access_token => _axios.default.create({
  baseURL: '/',
  timeout: 2000,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${access_token}`
  }
});

const save = async (access_token, data) => await AxiosInstance(access_token).post('/api/a/cms/save', data).then(res => res);

const config = {
  autoSave: true,
  charCounterCount: true,
  fontFamilySelection: true,
  fontSizeSelection: true,
  iconsTemplate: 'font_awesome_5r',
  imageMaxSize: 16 * 1024 * 1024,
  imageUploadParam: 'file',
  imageUploadMethod: 'POST',
  imageUploadURL: '/api/u/upload/',
  placeholderText: 'Edit Your Content Here!',
  pluginsEnabled: ['align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'emoticons', 'entities', // 'file',
  'fontFamily', 'fontSize', 'fullscreen', 'help', 'image', // 'imageManager',
  'inlineClass', 'inlineStyle', // 'lineBreaker',
  'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'print', // 'quickInsert',
  'quote', 'save', 'specialCharacters', 'table', 'url', 'video', 'wordPaste'],
  toolbarButtons: {
    moreText: {
      buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting'],
      buttonsVisible: 3
    },
    moreParagraph: {
      buttons: ['alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'outdent', 'indent', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'quote'],
      buttonsVisible: 6
    },
    moreRich: {
      buttons: ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'specialCharacters', 'insertHR'],
      buttonsVisible: 4
    },
    moreMisc: {
      buttons: ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'selectAll', 'html', 'help', 'save'],
      align: 'right',
      buttonsVisible: 2
    }
  },
  events: {},
  linkAutoPrefix: ''
};

class CmsEditPage extends _react.default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      model: '',
      topic: -1,
      subTopic: -1,
      title: '',
      hook: '',
      saved: false,
      content: '',
      articleId: -1,
      oidc: this.props.oidc
    };

    this.handleTopicChange = values => {
      const topic = values[0];
      const subTopic = values[1];
      this.setState({
        topic,
        subTopic,
        saved: false
      });
    };

    this.handleTitleChange = event => {
      const {
        value
      } = event.target;
      this.setState({
        title: value,
        saved: false
      });
    };

    this.handleHookChange = event => {
      const {
        value
      } = event.target;
      this.setState({
        hook: value,
        saved: false
      });
    };

    this.handleModelChange = model => {
      this.setState({
        model,
        saved: false
      });
    };

    this.handleResetClicked = event => {
      event.stopPropagation();
      this.setState({
        model: '',
        title: '',
        hook: '',
        saved: false,
        articleId: -1
      });
    };

    this.handleSave = requestBody => {
      const {
        topicId,
        title,
        summary,
        oidc,
        body,
        articleId
      } = requestBody;

      if (topicId !== -1 && title.length > 0 && summary.length > 0) {
        const response = save(oidc.user.access_token, {
          articleId: articleId !== -1 ? articleId : null,
          topicId,
          title,
          summary,
          createdByUserId: oidc.user.profile.sub,
          body: (0, _Util.updateCmsEditorBeforeSave)(body)
        });
        response.then(res => {
          console.log(res.data);
          this.setState({
            saved: true,
            articleId: res.data.id
          });
        });
      }
    };
  }

  componentDidMount() {
    const {
      loadResourceTopics
    } = this.props;
    loadResourceTopics();
  }

  render() {
    const {
      TextArea
    } = _input.default;
    const {
      resourceTopics
    } = this.props;
    const {
      topic,
      subTopic,
      title,
      hook,
      model,
      saved,
      oidc,
      articleId
    } = this.state;
    const requestBody = {
      title: (0, _util.cleanstring)(title),
      topicId: subTopic,
      summary: (0, _util.cleanstring)(hook),
      oidc,
      body: (0, _util.cleanstring)(model),
      articleId
    };
    const sql = `INSERT INTO article (topic_id, title, summary, created_by_user_id, body) VALUES (${subTopic}, '${(0, _util.cleanstring)(title)}', '${(0, _util.cleanstring)(hook)}', '1001', '${(0, _util.cleanstring)(model)}');`;
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        margin: 'auto',
        width: '80%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", null, "Topic"), /*#__PURE__*/_react.default.createElement(_cascader.default, {
      fieldNames: {
        label: 'title',
        value: 'id',
        children: 'children'
      },
      // style={{width: '400px', margin: "20px"}}
      size: "large",
      defaultValue: [`${topic}`, `${subTopic}`],
      options: resourceTopics,
      onChange: this.handleTopicChange
    })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", null, "Title"), /*#__PURE__*/_react.default.createElement(_input.default, {
      style: {
        width: '400px',
        margin: '20px'
      },
      value: title,
      onChange: this.handleTitleChange
    })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", null, "Hook"), /*#__PURE__*/_react.default.createElement(TextArea, {
      style: {
        width: '600px',
        margin: '20px'
      },
      rows: 3,
      value: hook,
      maxLength: 300,
      onChange: this.handleHookChange
    })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this.handleResetClicked
    }, "New Article"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: e => this.handleSave(requestBody)
    }, "Save"), /*#__PURE__*/_react.default.createElement("span", null, saved ? `Saved! ${(0, _moment.default)(new Date()).format('hh:mm:ss')}` : 'There are unsaved changes...'))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactFroalaWysiwyg.default, {
      tag: "textarea",
      config: config,
      model: model,
      onModelChange: this.handleModelChange
    })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, sql)));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  oidc: selectors.selectOidc,
  resourceTopics: selectors.getResourceTopics
});

const mapDispatchToProps = dispatch => {
  return {
    loadResourceTopics: () => dispatch(_topic.loadResourceTopicsAsync.request())
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CmsEditPage);

exports.default = _default;